import { Hold, HoldLevel } from 'app/models/hold-params'

// Panel heading. LendOS-placed items are "Locks"; Signing-Portal-placed items
// are Agent "Holds", qualified by the level they apply to ("Agent Trade Hold",
// "Agent Facility Hold", "Agent Deal Hold") so a card that also shows a cascaded
// facility/deal hold is never ambiguous. A "Cascaded from {source}" subtitle
// appears when it came from a level above the surface being viewed.
export function holdPanelTitle(
  hold: Hold,
  viewLevel: HoldLevel,
): { title: string; subtitle?: string } {
  const level = hold.origin.level
  const agent = hold.system === 'SigningPortal'
  const title = agent ? `Agent ${level} Hold` : `${level} Lock`
  const subtitle = level !== viewLevel ? `Cascaded from ${hold.origin.sourceName}` : undefined
  return { title, subtitle }
}
